// use this Api as a function to make api calls;
import axiosInstance from '../axios';
import { API_ROUTES } from '../../enums/API_ROUTES';
import { SortOptions, SortType } from '../../enums/SORT';
import { isNumber } from 'lodash';

export const deleteGroupById = async (orgId: string) => {
  const res = await axiosInstance.delete(`${API_ROUTES.GROUPS}${orgId}`);
  return res;
};

export const getGroups = async (data: {
  search?: string;
  sort?: SortType;
  sortOption?: SortOptions;
  page?: number;
  limit?: number;
  filter_out_viewers?: boolean;
  ignoreGroupIds?: string[];
}) => {
  const { search, sort, sortOption, page, limit, filter_out_viewers, ignoreGroupIds } = data;
  const res = await axiosInstance.get(
    `${API_ROUTES.GROUPS}?search=${search ?? ''}&sort=${sort ? sort : SortType.ASC}&sortField=${
      sortOption ? sortOption : SortOptions.NAME
    }${isNumber(page) ? '&page=' + (page + 1) : ''}${isNumber(limit) ? '&limit=' + limit : ''}${
      filter_out_viewers ? `&filter_out_viewers=${filter_out_viewers}` : ''
    }${ignoreGroupIds ? `&ignore_group_ids=${ignoreGroupIds}` : ''}
    `,
  );
  return res.data;
};

type TUpdateGroupUsers = {
  title?: string;
  groupdId: string;
  usersToRemove?: string[];
  usersToAdd?: string[];
};

export const updateGroupUsers = async (args: TUpdateGroupUsers) => {
  const res = await axiosInstance.patch(`${API_ROUTES.GROUPS}${args.groupdId}`, {
    title: args.title,
    usersToRemove: args.usersToRemove,
    usersToAdd: args.usersToAdd,
  });
  return res;
};

type TpatchGroupAnalysts = {
  usersToAdd?: string[];
  usersToRemove?: string[];
  allow_download_own_composers?: boolean;
};

export const patchGroupAnalysts = async (groupId: string, data: TpatchGroupAnalysts) => {
  const res = await axiosInstance.patch(`${API_ROUTES.GROUPS}${groupId}`, data);
  return res;
};

type TpatchGroupViewers = {
  usersToAdd?: string[];
  usersToRemove: string[];
};

export const patchGroupViewers = async (groupId: string, data: TpatchGroupViewers) => {
  const res = await axiosInstance.patch(`${API_ROUTES.GROUPS}${groupId}`, data);
  return res;
};

export const postCreateNewGroup = async (data: { title: string; analysts: string[] | number[]; viewers: string[] | number[] }) => {
  const res = await axiosInstance.post(`${API_ROUTES.GROUPS}`, data);
  return res;
};

export const getGroupById = async (id: string) => {
  const res = await axiosInstance.get(`group/{id}?id=${id}`);
  return res;
};

export const getGroupsWithOrganizations = async (search?: string, page?: number, limit?: number) => {
  const res = await axiosInstance.get(
    `${API_ROUTES.GROUPS_WITH_ORGS}?sort=asc&sortField=updated_at&search=${search ?? ''}${isNumber(page) ? `&page=${page + 1}` : ''}${
      isNumber(limit) ? `&limit=${limit}` : ''
    }`,
  );
  return res.data;
};

// 2. Create a group with organizations
export const postCreateGroupWithOrganizations = async (data: {
  title: string;
  analysts: (string | number)[];
  viewers: (string | number)[];
  type?: string;
  organizations?: (string | number)[];
}) => {
  return await axiosInstance.post(`${API_ROUTES.GROUPS_WITH_ORGS}`, data);
};

// 3. Update a group's organizations
export const patchUpdateGroupWithOrganizations = async (
  groupId: string,
  data: {
    orgsToAdd?: string[];
    orgsToRemove?: string[];
    title?: string;
    analystsToAdd?: string[];
    analystsToRemove?: string[];
    viewersToAdd?: string[];
    viewersToRemove?: string[];
  },
) => {
  return await axiosInstance.patch(`${API_ROUTES.GROUPS_WITH_ORGS}/${groupId}`, data);
};
